module.exports = __webpack_public_path__ + "static/media/mdi_format_list_bulleted.2a0ca5e8.svg";